import * as React from "react";

export const SvgProfile = ({ "data-testid": dataTestId = null, ...props }) => (
	<svg width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg" data-testid={dataTestId} {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M10.004 2.8a3.2 3.2 0 1 0 0 6.4 3.2 3.2 0 0 0 0-6.4Zm-4 3.2a4 4 0 1 1 8 0 4 4 0 0 1-8 0ZM16.63 13.975a14.122 14.122 0 0 0-13.255 0 .326.326 0 0 0-.173.288V17.2c0 .221.18.4.4.4h12.8a.4.4 0 0 0 .4-.4v-2.937a.326.326 0 0 0-.173-.288ZM3 13.268a14.922 14.922 0 0 1 14.005 0c.367.196.597.578.597.995V17.2a1.2 1.2 0 0 1-1.2 1.2h-12.8a1.2 1.2 0 0 1-1.2-1.2v-2.937c0-.417.23-.8.598-.995Z"
			fill={props.color ?? "#A8A8A8"}
			stroke={props.color ?? "#A8A8A8"}
			strokeWidth={0.5}
		/>
	</svg>
);
